<template>
  <div class="page-effect">
    <header class="header-navbar sticky-top">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="d-md-flex align-items-center justify-content-between">
              <div class="left-logo" style="width: 100%">
                <img v-if="BannerURL" id="imgBanner" v-bind:src="BannerURL" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <section
      class="
        register-page-wrapper
        body-content
        event-reg-speakers event_details_w
      "
      style="background-color: #ffffff"
    >
      <div class="container">
        <div class="col-md-10 mx-auto plr-8">
          <div class="row">
            <div class="col-lg-12 mob-pt-0">
              <div
                v-show="
                  ![
                    'E1647872860081',
                    'E1615533069198',
                    'E1637947380160',
                  ].includes(EventsData[0].eventId)
                "
                class="top-right-login text-right hdr-btn mb-md-3 login-ico"
              >
                <!-- <a class="event-List">Event List</a> -->
                &nbsp;
                <a
                  v-show="ShowEventListLink"
                  v-on:click="goForEventList"
                  class="event-List"
                  >Event List</a
                >
                <a v-on:click="goForLogin" class="login">Login</a>
              </div>
              <div class="event_banner rounded overflow-hidden">
                <!-- <img src="images/event-banner.jpg" alt="e2m" /> -->
                <!-- <img id="imgBanner" v-bind:src="BannerURL" alt="e2m" /> -->
                <v-img
                  id="imgBannerEvnt"
                  :src="EventsData.length > 0 ? EventsData[0].EventLogo : ''"
                />
              </div>
              <div class="row my-4">
                <div class="col-md-8 mob-pt-0">
                  <h1 class="page-head mb-2" v-if="EventsData[0]">
                    {{ EventsData[0].EventName }}
                  </h1>
                  &nbsp;
                  <div
                    class="top-right-login"
                    v-show="
                      ![
                        'E1647872860081',
                        'E1615533069198',
                        'E1637947380160',
                        'E1651675626344',
                      ].includes(EventsData[0].eventId)
                    "
                  >
                    <a
                      href="javascript:void(0);"
                      style="pointer-events: none"
                      class="event-List mb-0"
                      v-if="EventsData[0]"
                      >{{ EventsData[0].EventStartDateZ }}&nbsp; to &nbsp;{{
                        EventsData[0].EventEndDateZ
                      }}
                      &nbsp;{{ EventsData[0].EventTimezoneZ }}</a
                    >
                  </div>
                </div>
                <div class="col-md-4 text-md-right mob-pb-0">
                  <button
                    id="btnRegister"
                    v-on:click="goForRegister"
                    type="submit"
                    class="btn reg-button text-uppercase"
                    style="
                      background: #288af2 !important;
                      color: #fff !important;
                    "
                  >
                    Register Now
                  </button>
                </div>
              </div>
            </div>
            <!-----hosted by------->
            <div v-show="ShowHostedByPanel" class="col-md-12 mob-pt-0">
              <div
                class="
                  media
                  border
                  p-4
                  full-width
                  hosted-box
                  align-items-center
                "
              >
                <!-- <img
                  src="images/reg-banner.jpg"
                  alt="John Doe"
                  class="mr-3 rounded-circle"
                  style="width:60px;height: 60px;"
                />-->
                <span
                  class="imageCircle height-removed reg-prof-img new-reg p-2"
                >
                  <img id="imgBanner" v-bind:src="clientLogoUrl" />
                </span>
                <div class="media-body pl-2">
                  <h6>Hosted By</h6>
                  <h5>{{ clientName }}</h5>
                </div>
                <p v-html="clientProfile" class="m-0"></p>
              </div>
            </div>
            <!------------>
          </div>
          <!------tab area start-------->
          <section
            class="session-list-wrapper p-0 mt-3 SessionlistMultitracker"
          >
            <div class="reg-page-tab-hld">
              <ul class="nav nav-tabs mb-4" role="tablist">
                <!--<li class="nav-item">
                  <a
                    class="nav-link active acnhDescription"
                    data-toggle="tab"
                    href="#description"
                    >description</a
                  >
                </li>
                 <li class="nav-item">
                  <a class="nav-link acnhDescription" data-toggle="tab" href="#Sessions">Sessions</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link acnhDescription" data-toggle="tab" href="#SpeakersHost">Speakers & Host</a>
                </li>-->
              </ul>

              <!------tab content start------>
              <div class="tab-content">
                <div
                  id="description"
                  v-if="EventsData[0]"
                  v-html="EventsData[0].Description"
                  class="tab-pane active"
                ></div>
                <div id="Sessions" class="tab-pane">
                  <!-------session box---->
                  <div class="white-box-wrapper single-session" id="divbox0">
                    <!----time area-->
                    <div class="time-location">
                      <ul>
                        <li>
                          <span>
                            2:00 PM
                            <br />2:15 PM
                          </span>
                        </li>
                        <li style="display: none">
                          <span></span>
                        </li>
                      </ul>
                    </div>
                    <!----time area-->
                    <div class="row main-divider one-session">
                      <div class="col-md-7">
                        <div class="left-area-hld">
                          <h2
                            data-toggle="modal"
                            data-target="#session-details"
                          >
                            Opening Key Note
                          </h2>
                          <p>Everything about no code tools.</p>
                        </div>
                      </div>

                      <div class="col-md-5">
                        <div class="right-area-hld">
                          <div id="dvBroadcast">
                            <!--01.06.2020 speaker--->
                            <a href class="schedule-speaker w-inline-block">
                              <img
                                src="https://assets.website-files.com/5e6b831c127853b6a92d6e48/5e6b9efd27a8a5dc08ba2f0b_person1.jpg"
                                alt
                                class="schedule-speaker-image"
                              />
                            </a>
                            <a href class="schedule-speaker w-inline-block">
                              <img
                                src="https://assets.website-files.com/5e6b831c127853b6a92d6e48/5e6b9efd27a8a5dc08ba2f0b_person1.jpg"
                                alt
                                class="schedule-speaker-image"
                              />
                            </a>
                            <a href class="schedule-speaker w-inline-block">
                              <img
                                src="https://assets.website-files.com/5e6b831c127853b6a92d6e48/5e6b9efd27a8a5dc08ba2f0b_person1.jpg"
                                alt
                                class="schedule-speaker-image"
                              />
                            </a>
                            <!----->
                            <a class="icon-bookmark1 bmark-pupupbtn">
                              <div class="icon-hld">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="32"
                                  height="32"
                                  viewBox="0 0 32 30.37"
                                  fill="#242432"
                                >
                                  <path
                                    id="join-session.svg"
                                    d="M1302.22,1402c-0.76,0-1.89-.04-2.47-0.04a13.991,13.991,0,0,0-3.03-20.64l1.44-1.43A15.974,15.974,0,0,1,1302.22,1402Zm-4.57-3.99c-0.57,0-1.49-.03-2.39-0.03a8,8,0,0,0-2.94-12.26l1.49-1.49A9.994,9.994,0,0,1,1297.65,1398.01Zm-3.66-4.97a4.759,4.759,0,0,1-1.47,3.51,5,5,0,0,1-7.06,0,4.759,4.759,0,0,1-1.47-3.51,4.89,4.89,0,0,1,1.47-3.54,4.927,4.927,0,0,1,7.06,0A4.89,4.89,0,0,1,1293.99,1393.04Zm-2.84-2.16a3.01,3.01,0,0,0-5.15,2.15,2.827,2.827,0,0,0,.87,2.12,3.146,3.146,0,0,0,4.28,0,2.827,2.827,0,0,0,.87-2.12A2.926,2.926,0,0,0,1291.15,1390.88ZM1281,1393a7.956,7.956,0,0,0,2.08,5.37c-0.67.38-1.29,0.53-1.86,0.91a10,10,0,0,1,2.97-15.05l1.49,1.49A8.005,8.005,0,0,0,1281,1393Zm-6,0a13.919,13.919,0,0,0,2.75,8.33,9.344,9.344,0,0,0-.47,2.55,15.977,15.977,0,0,1,2.56-23.99l1.44,1.43A14,14,0,0,0,1275,1393Zm5.83,9.34a12.143,12.143,0,0,1,4.07-1.81,17.378,17.378,0,0,1,4.09-.54c0.1,0,.21.02,0.3,0.02a2.545,2.545,0,0,0-.16,2c-0.05,0-.09-0.01-0.13-0.01a13.352,13.352,0,0,0-5,1c-1.68.66-3,1.73-3,2v2h8.4a3.147,3.147,0,0,0-.3,2.01h-10.11v-3.85A3.494,3.494,0,0,1,1280.83,1402.34Zm9.88,1.7h3.33v-3.34a0.96,0.96,0,1,1,1.92,0v3.34h3.34a0.96,0.96,0,1,1,0,1.92h-3.34v3.33a0.96,0.96,0,0,1-1.92,0v-3.33h-3.33A0.96,0.96,0,0,1,1290.71,1404.04Z"
                                    transform="translate(-1273 -1379.88)"
                                  />
                                </svg>
                              </div>
                              <span>Live Panel</span>
                            </a>
                            <!------calender icon start-->
                            <div class="session-calender">
                              <a class target="_blank">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21"
                                  height="21"
                                  viewBox="0 0 21 21"
                                >
                                  <path
                                    id="add-to-calendar.svg"
                                    d="M603,362v3h-2v-3h-3v-2h3v-3h2v3h3v2h-3Zm-5-6v-2h2v2h-2Zm-6,2v2h-2v-2h2Zm11-3v-3H587v10h9v2H586a1,1,0,0,1-1-1V347a1,1,0,0,1,1-1h3v-2h2v2h8v-2h2v2h3a1,1,0,0,1,1,1v8h-2Zm0-7H587v2h16v-2Zm-9,6h2v2h-2v-2Zm2,6h-2v-2h2v2Z"
                                    transform="translate(-585 -344)"
                                  />
                                </svg>
                              </a>
                              <span>Add to Calenda</span>
                            </div>
                            <!------calender icon end-->
                          </div>
                        </div>
                      </div>
                    </div>
                    <!----session box end---->
                  </div>

                  <!-------session box end---->
                  <!-------session box---->
                  <div class="white-box-wrapper single-session" id="divbox0">
                    <!----time area-->
                    <div class="time-location">
                      <ul>
                        <li>
                          <span>
                            2:00 PM
                            <br />2:15 PM
                          </span>
                        </li>
                        <li style="display: none">
                          <span></span>
                        </li>
                      </ul>
                    </div>
                    <!----time area-->
                    <div class="row main-divider one-session">
                      <div class="col-md-7">
                        <div class="left-area-hld">
                          <h2
                            data-toggle="modal"
                            data-target="#session-details"
                          >
                            Opening Key Note
                          </h2>
                          <p>Everything about no code tools.</p>
                        </div>
                      </div>

                      <div class="col-md-5">
                        <div class="right-area-hld">
                          <div id="dvBroadcast">
                            <!--01.06.2020 speaker--->
                            <a href class="schedule-speaker w-inline-block">
                              <img
                                src="https://assets.website-files.com/5e6b831c127853b6a92d6e48/5e6b9efd27a8a5dc08ba2f0b_person1.jpg"
                                alt
                                class="schedule-speaker-image"
                              />
                            </a>
                            <a href class="schedule-speaker w-inline-block">
                              <img
                                src="https://assets.website-files.com/5e6b831c127853b6a92d6e48/5e6b9efd27a8a5dc08ba2f0b_person1.jpg"
                                alt
                                class="schedule-speaker-image"
                              />
                            </a>
                            <a href class="schedule-speaker w-inline-block">
                              <img
                                src="https://assets.website-files.com/5e6b831c127853b6a92d6e48/5e6b9efd27a8a5dc08ba2f0b_person1.jpg"
                                alt
                                class="schedule-speaker-image"
                              />
                            </a>
                            <!----->
                            <a class="icon-bookmark1 bmark-pupupbtn">
                              <div class="icon-hld">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="32"
                                  height="32"
                                  viewBox="0 0 32 30.37"
                                  fill="#242432"
                                >
                                  <path
                                    id="join-session.svg"
                                    d="M1302.22,1402c-0.76,0-1.89-.04-2.47-0.04a13.991,13.991,0,0,0-3.03-20.64l1.44-1.43A15.974,15.974,0,0,1,1302.22,1402Zm-4.57-3.99c-0.57,0-1.49-.03-2.39-0.03a8,8,0,0,0-2.94-12.26l1.49-1.49A9.994,9.994,0,0,1,1297.65,1398.01Zm-3.66-4.97a4.759,4.759,0,0,1-1.47,3.51,5,5,0,0,1-7.06,0,4.759,4.759,0,0,1-1.47-3.51,4.89,4.89,0,0,1,1.47-3.54,4.927,4.927,0,0,1,7.06,0A4.89,4.89,0,0,1,1293.99,1393.04Zm-2.84-2.16a3.01,3.01,0,0,0-5.15,2.15,2.827,2.827,0,0,0,.87,2.12,3.146,3.146,0,0,0,4.28,0,2.827,2.827,0,0,0,.87-2.12A2.926,2.926,0,0,0,1291.15,1390.88ZM1281,1393a7.956,7.956,0,0,0,2.08,5.37c-0.67.38-1.29,0.53-1.86,0.91a10,10,0,0,1,2.97-15.05l1.49,1.49A8.005,8.005,0,0,0,1281,1393Zm-6,0a13.919,13.919,0,0,0,2.75,8.33,9.344,9.344,0,0,0-.47,2.55,15.977,15.977,0,0,1,2.56-23.99l1.44,1.43A14,14,0,0,0,1275,1393Zm5.83,9.34a12.143,12.143,0,0,1,4.07-1.81,17.378,17.378,0,0,1,4.09-.54c0.1,0,.21.02,0.3,0.02a2.545,2.545,0,0,0-.16,2c-0.05,0-.09-0.01-0.13-0.01a13.352,13.352,0,0,0-5,1c-1.68.66-3,1.73-3,2v2h8.4a3.147,3.147,0,0,0-.3,2.01h-10.11v-3.85A3.494,3.494,0,0,1,1280.83,1402.34Zm9.88,1.7h3.33v-3.34a0.96,0.96,0,1,1,1.92,0v3.34h3.34a0.96,0.96,0,1,1,0,1.92h-3.34v3.33a0.96,0.96,0,0,1-1.92,0v-3.33h-3.33A0.96,0.96,0,0,1,1290.71,1404.04Z"
                                    transform="translate(-1273 -1379.88)"
                                  />
                                </svg>
                              </div>
                              <span>Live Panel</span>
                            </a>
                            <!------calender icon start-->
                            <div class="session-calender">
                              <a class target="_blank">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21"
                                  height="21"
                                  viewBox="0 0 21 21"
                                >
                                  <path
                                    id="add-to-calendar.svg"
                                    d="M603,362v3h-2v-3h-3v-2h3v-3h2v3h3v2h-3Zm-5-6v-2h2v2h-2Zm-6,2v2h-2v-2h2Zm11-3v-3H587v10h9v2H586a1,1,0,0,1-1-1V347a1,1,0,0,1,1-1h3v-2h2v2h8v-2h2v2h3a1,1,0,0,1,1,1v8h-2Zm0-7H587v2h16v-2Zm-9,6h2v2h-2v-2Zm2,6h-2v-2h2v2Z"
                                    transform="translate(-585 -344)"
                                  />
                                </svg>
                              </a>
                              <span>Add to Calenda</span>
                            </div>
                            <!------calender icon end-->
                          </div>
                        </div>
                      </div>
                    </div>
                    <!----session box end---->
                  </div>

                  <!-------session box end---->
                  <!-------session box---->
                  <div class="white-box-wrapper single-session" id="divbox0">
                    <!----time area-->
                    <div class="time-location">
                      <ul>
                        <li>
                          <span>
                            2:00 PM
                            <br />2:15 PM
                          </span>
                        </li>
                        <li style="display: none">
                          <span></span>
                        </li>
                      </ul>
                    </div>
                    <!----time area-->
                    <div class="row main-divider one-session">
                      <div class="col-md-7">
                        <div class="left-area-hld">
                          <h2
                            data-toggle="modal"
                            data-target="#session-details"
                          >
                            Opening Key Note
                          </h2>
                          <p>Everything about no code tools.</p>
                        </div>
                      </div>

                      <div class="col-md-5">
                        <div class="right-area-hld">
                          <div id="dvBroadcast">
                            <!--01.06.2020 speaker--->
                            <a href class="schedule-speaker w-inline-block">
                              <img
                                src="https://assets.website-files.com/5e6b831c127853b6a92d6e48/5e6b9efd27a8a5dc08ba2f0b_person1.jpg"
                                alt
                                class="schedule-speaker-image"
                              />
                            </a>
                            <a href class="schedule-speaker w-inline-block">
                              <img
                                src="https://assets.website-files.com/5e6b831c127853b6a92d6e48/5e6b9efd27a8a5dc08ba2f0b_person1.jpg"
                                alt
                                class="schedule-speaker-image"
                              />
                            </a>
                            <a href class="schedule-speaker w-inline-block">
                              <img
                                src="https://assets.website-files.com/5e6b831c127853b6a92d6e48/5e6b9efd27a8a5dc08ba2f0b_person1.jpg"
                                alt
                                class="schedule-speaker-image"
                              />
                            </a>
                            <!----->
                            <a class="icon-bookmark1 bmark-pupupbtn">
                              <div class="icon-hld">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="32"
                                  height="32"
                                  viewBox="0 0 32 30.37"
                                  fill="#242432"
                                >
                                  <path
                                    id="join-session.svg"
                                    d="M1302.22,1402c-0.76,0-1.89-.04-2.47-0.04a13.991,13.991,0,0,0-3.03-20.64l1.44-1.43A15.974,15.974,0,0,1,1302.22,1402Zm-4.57-3.99c-0.57,0-1.49-.03-2.39-0.03a8,8,0,0,0-2.94-12.26l1.49-1.49A9.994,9.994,0,0,1,1297.65,1398.01Zm-3.66-4.97a4.759,4.759,0,0,1-1.47,3.51,5,5,0,0,1-7.06,0,4.759,4.759,0,0,1-1.47-3.51,4.89,4.89,0,0,1,1.47-3.54,4.927,4.927,0,0,1,7.06,0A4.89,4.89,0,0,1,1293.99,1393.04Zm-2.84-2.16a3.01,3.01,0,0,0-5.15,2.15,2.827,2.827,0,0,0,.87,2.12,3.146,3.146,0,0,0,4.28,0,2.827,2.827,0,0,0,.87-2.12A2.926,2.926,0,0,0,1291.15,1390.88ZM1281,1393a7.956,7.956,0,0,0,2.08,5.37c-0.67.38-1.29,0.53-1.86,0.91a10,10,0,0,1,2.97-15.05l1.49,1.49A8.005,8.005,0,0,0,1281,1393Zm-6,0a13.919,13.919,0,0,0,2.75,8.33,9.344,9.344,0,0,0-.47,2.55,15.977,15.977,0,0,1,2.56-23.99l1.44,1.43A14,14,0,0,0,1275,1393Zm5.83,9.34a12.143,12.143,0,0,1,4.07-1.81,17.378,17.378,0,0,1,4.09-.54c0.1,0,.21.02,0.3,0.02a2.545,2.545,0,0,0-.16,2c-0.05,0-.09-0.01-0.13-0.01a13.352,13.352,0,0,0-5,1c-1.68.66-3,1.73-3,2v2h8.4a3.147,3.147,0,0,0-.3,2.01h-10.11v-3.85A3.494,3.494,0,0,1,1280.83,1402.34Zm9.88,1.7h3.33v-3.34a0.96,0.96,0,1,1,1.92,0v3.34h3.34a0.96,0.96,0,1,1,0,1.92h-3.34v3.33a0.96,0.96,0,0,1-1.92,0v-3.33h-3.33A0.96,0.96,0,0,1,1290.71,1404.04Z"
                                    transform="translate(-1273 -1379.88)"
                                  />
                                </svg>
                              </div>
                              <span>Live Panel</span>
                            </a>
                            <!------calender icon start-->
                            <div class="session-calender">
                              <a class target="_blank">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21"
                                  height="21"
                                  viewBox="0 0 21 21"
                                >
                                  <path
                                    id="add-to-calendar.svg"
                                    d="M603,362v3h-2v-3h-3v-2h3v-3h2v3h3v2h-3Zm-5-6v-2h2v2h-2Zm-6,2v2h-2v-2h2Zm11-3v-3H587v10h9v2H586a1,1,0,0,1-1-1V347a1,1,0,0,1,1-1h3v-2h2v2h8v-2h2v2h3a1,1,0,0,1,1,1v8h-2Zm0-7H587v2h16v-2Zm-9,6h2v2h-2v-2Zm2,6h-2v-2h2v2Z"
                                    transform="translate(-585 -344)"
                                  />
                                </svg>
                              </a>
                              <span>Add to Calenda</span>
                            </div>
                            <!------calender icon end-->
                          </div>
                        </div>
                      </div>
                    </div>
                    <!----session box end---->
                  </div>

                  <!-------session box end---->
                </div>
                <div id="SpeakersHost" class="tab-pane">
                  <!-----speakers list start------->
                  <div class="media">
                    <div class="i-holder">
                      <img
                        class="mr-3"
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSpeaker%2F1.%20Dr%20Ivan%20Misner.jpg?alt=media"
                        alt="Generic placeholder image"
                      />
                    </div>
                    <div class="media-body pl-2">
                      <h5 class="mt-0">Media heading</h5>
                      <p class="po-ad">BNI | District Director</p>
                      <p>
                        Cras sit amet nibh libero, in gravida nulla. Nulla vel
                        metus scelerisque ante sollicitudin. Cras purus odio,
                        vestibulum in vulputate at, tempus viverra turpis. Fusce
                        condimentum nunc ac nisi vulputate fringilla. Donec
                        lacinia congue felis in faucibus.
                      </p>
                      <!---------->
                      <div class="social-icon d-flex">
                        <a
                          id="anchFacebook"
                          href="https://www.facebook.com/"
                          target="_blank"
                        >
                          <span id="spnFacebook" style>
                            <i aria-hidden="true" class="fa fa-facebook"></i>
                          </span>
                        </a>
                        <a
                          id="anchTwitter"
                          href="https://twitter.com/explore"
                          target="_blank"
                        >
                          <span id="spnTwitter" style>
                            <i aria-hidden="true" class="fa fa-twitter"></i>
                          </span>
                        </a>
                        <a
                          id="anchLinkedIn"
                          href="https://www.linkedin.com/"
                          target="_blank"
                        >
                          <span id="spnLinkedIn" style>
                            <i aria-hidden="true" class="fa fa-linkedin"></i>
                          </span>
                        </a>
                      </div>
                      <!---------->
                    </div>
                  </div>
                  <!-----speakers list box end------->
                  <!-----speakers list start------->
                  <div class="media">
                    <div class="i-holder">
                      <img
                        class="mr-3"
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSpeaker%2F1.%20Dr%20Ivan%20Misner.jpg?alt=media"
                        alt="Generic placeholder image"
                      />
                    </div>
                    <div class="media-body pl-2">
                      <h5 class="mt-0">Media heading</h5>
                      <p class="po-ad">BNI | District Director</p>
                      <p>
                        Cras sit amet nibh libero, in gravida nulla. Nulla vel
                        metus scelerisque ante sollicitudin. Cras purus odio,
                        vestibulum in vulputate at, tempus viverra turpis. Fusce
                        condimentum nunc ac nisi vulputate fringilla. Donec
                        lacinia congue felis in faucibus.
                      </p>
                      <!---------->
                      <div class="social-icon d-flex">
                        <a
                          id="anchFacebook"
                          href="https://www.facebook.com/"
                          target="_blank"
                        >
                          <span id="spnFacebook" style>
                            <i aria-hidden="true" class="fa fa-facebook"></i>
                          </span>
                        </a>
                        <a
                          id="anchTwitter"
                          href="https://twitter.com/explore"
                          target="_blank"
                        >
                          <span id="spnTwitter" style>
                            <i aria-hidden="true" class="fa fa-twitter"></i>
                          </span>
                        </a>
                        <a
                          id="anchLinkedIn"
                          href="https://www.linkedin.com/"
                          target="_blank"
                        >
                          <span id="spnLinkedIn" style>
                            <i aria-hidden="true" class="fa fa-linkedin"></i>
                          </span>
                        </a>
                      </div>
                      <!---------->
                    </div>
                  </div>
                  <!-----speakers list box end------->
                  <!-----speakers list start------->
                  <div class="media">
                    <div class="i-holder">
                      <img
                        class="mr-3"
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSpeaker%2F1.%20Dr%20Ivan%20Misner.jpg?alt=media"
                        alt="Generic placeholder image"
                      />
                    </div>
                    <div class="media-body pl-2">
                      <h5 class="mt-0">Media heading</h5>
                      <p class="po-ad">BNI | District Director</p>
                      <p>
                        Cras sit amet nibh libero, in gravida nulla. Nulla vel
                        metus scelerisque ante sollicitudin. Cras purus odio,
                        vestibulum in vulputate at, tempus viverra turpis. Fusce
                        condimentum nunc ac nisi vulputate fringilla. Donec
                        lacinia congue felis in faucibus.
                      </p>
                    </div>
                  </div>
                  <!-----speakers list box end------->
                  <!-----speakers list start------->
                  <div class="media">
                    <div class="i-holder">
                      <img
                        class="mr-3"
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSpeaker%2F1.%20Dr%20Ivan%20Misner.jpg?alt=media"
                        alt="Generic placeholder image"
                      />
                    </div>
                    <div class="media-body pl-2">
                      <h5 class="mt-0">Media heading</h5>
                      <p class="po-ad">BNI | District Director</p>
                      <p>
                        Cras sit amet nibh libero, in gravida nulla. Nulla vel
                        metus scelerisque ante sollicitudin. Cras purus odio,
                        vestibulum in vulputate at, tempus viverra turpis. Fusce
                        condimentum nunc ac nisi vulputate fringilla. Donec
                        lacinia congue felis in faucibus.
                      </p>
                    </div>
                  </div>
                  <!-----speakers list box end------->
                </div>
              </div>
              <!------tab content end------>
            </div>
          </section>
          <!------tab area end-------->
        </div>
      </div>
    </section>
  </div>
</template>
<style>
#success-modal span.btn-pink.sussecc-btn {
  margin-top: 15px;
}
</style>
<script>
import jQuery from "jquery";
let $ = jQuery;
import { bus } from "@/main";
import APIs from "@/components/APIInit";
// import db from "../components/firebaseInit";
import router from "../router";
var self;
// import Vue from "vue";
// import VueMoment from "vue-moment";
import moment from "moment-timezone";
import firebase from "firebase";
import axios from "axios";
export default {
  data() {
    return {
      AllowRegistration: true,
      ShowEventListLink: true,
      ShowHostedByPanel: true,
      eventcollectionname: "",
      btntextColor: "black",
      btnBackColor: "#ef222b",
      BannerURL: "",
      EventsData: [],
      clientID: "",
      clientName: "",
      hostName: "",
      clientLogoUrl: "",
      eventID: "",
      clientProfile: "",
      customDomain: "",
      mobileBanner: "",
      desktopBanner: "",
    };
  },
  beforeCreate() {
    $("#topmenu").hide();
    $("#leftmenu").hide();
  },
  created() {
    self = this;
    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });
  },
  async mounted() {
    self.EventsData = [];
    var eventId = this.$route.params.e; // this.$route.query.e;
    self.eventID = eventId;
    console.log(eventId);
    //const storage = firebase.storage();
    //const storageRef = storage.ref();
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      self.hostName = HOSTURL ? HOSTURL : self.LocalhostDomain();
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
    }
    var path;
    //console.log(self.hostName);
    if (this.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = APIs.googleSoragePath;
    }

    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then(async (res) => {
        if (res && res.data) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        console.log("res===1", res.data);
        self.clientID = res.data.ClientId;
        self.clientName = res.data.ClientName;
        self.customDomain = res.data.CustomDomain;
        axios
          .get(
            APIs.EventBrandingJsonData +
              "?iid=OA_UAT" +
              "&cid=" +
              self.clientID +
              "&eid=" +
              self.eventID
          )
          .then(async (res) => {
            console.log("res===2", res.data);
            if (res.data.status == 0) {
              this.item = res.data.result;
              if (
                res.data.result.EventInfo &&
                res.data.result.EventInfo.EventBanner
              ) {
                self.desktopBanner = res.data.result.EventInfo.EventBanner;
              } else if (
                res.data.result.ClientInfo &&
                res.data.result.ClientInfo.EventListAssets.banner2048x88
              ) {
                self.desktopBanner =
                  res.data.result.ClientInfo.EventListAssets.banner2048x88;
              }

              if (
                res.data.result.EventInfo &&
                res.data.result.EventInfo.EventBannerMobile
              ) {
                self.mobileBanner = res.data.result.EventInfo.EventBannerMobile;
              } else if (
                res.data.result.ClientInfo &&
                res.data.result.ClientInfo.EventListAssets.banner750x103
              ) {
                self.mobileBanner =
                  res.data.result.ClientInfo.EventListAssets.banner750x103;
              }
              self.initScreen();

              var dateFormat = require("dateformat");

              console.log(res.data.result.EventInfo.EventFullName);
              var obj = new Object();

              obj.eventId = eventId;
              obj.EventName = res.data.result.EventInfo.EventFullName;
              document.title =
                res.data.result.EventInfo.EventFullName +
                " - " +
                self.clientName;
              // obj.EventTimezone = response.data.EventInfo.TimeZone; // moment.tz.guess();
              obj.EventTimezoneZ = moment.tz.guess();

              console.log(
                "response.data.EventInfo:- " + res.data.result.EventInfo
              );
              obj.EventLogo = res.data.result.EventInfo.EventLogo;
              obj.Description = res.data.result.EventInfo.Description;
              self.AllowRegistration =
                res.data.result.EventInfo.AllowRegistration == undefined
                  ? true
                  : res.data.result.EventInfo.AllowRegistration;

              obj.EventStartDate = dateFormat(
                res.data.result.EventInfo.EventStartDate,
                "mmm dd, hh:MM TT"
              );

              obj.EventEndDate = dateFormat(
                res.data.result.EventInfo.EventEndDate,
                "mmm dd, hh:MM TT"
              );

              obj.EventStartDateZ = self.GetTimeByZone(
                res.data.result.EventInfo.EventStartDate,
                res.data.result.EventInfo.TimeZone
              );

              obj.EventStartDateZ = dateFormat(
                obj.EventStartDateZ,
                "mmm dd, hh:MM TT"
              );
              obj.EventEndDateZ = self.GetTimeByZone(
                res.data.result.EventInfo.EventEndDate,
                res.data.result.EventInfo.TimeZone
              );

              obj.EventEndDateZ = dateFormat(
                obj.EventEndDateZ,
                "mmm dd, hh:MM TT"
              );
              self.EventsData.push(obj);
              //------------------------------------------------------
              self.clientName = res.data.result.HostInfo.Name;
              self.clientLogoUrl = res.data.result.HostInfo.Logo;
              self.clientProfile = res.data.result.HostInfo.Profile;
              self.getButtonBranding(self.hostName);
              self.getStaticFieldSettings(eventId);
            }
          });
      });
  },
  methods: {
    initScreen() {
      if (window.innerWidth > 768) {
        self.BannerURL = self.desktopBanner;
      } else {
        self.BannerURL = self.mobileBanner;
      }
    },
    getStaticFieldSettings: function (eventId) {
      debugger;
      var evntCol = "OA_UAT_" + self.clientID + eventId;
      const storage = firebase.storage();
      const storageRef = storage.ref();
      const objStaticFieldRef = storageRef.child(
        evntCol + "/Registration/DefaultRegFormSettings.JSON"
      );

      objStaticFieldRef.getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          console.log(
            "static Response Data:- " +
              JSON.stringify(response.data.LandingPageShowEventListLink)
          );
          //------------------------------------------------------------------
          self.ShowEventListLink = response.data.LandingPageShowEventListLink;
          self.ShowHostedByPanel = response.data.LandingPageShowHostedByPanel;
          //-------------------------------------------------------------------------------------
        });
      });
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    getButtonBranding: function (hostName) {
      var path;
      if (hostName.toLowerCase().indexOf("uat") > -1) {
        path = "https://resources.e2m.live/uate2monair.appspot.com/";
      } else {
        path = APIs.googleSoragePath;
      }
      axios
        .get(
          path + "OA_UAT%2FClients%2FHosts%2F" + hostName + ".json?alt=media"
        )
        .then((res) => {
          debugger;
          self.btnBackColor = res.data.LoginAssets.loginButtonFillColor;
          self.btntextColor = res.data.LoginAssets.loginButtonTextColor;
          //$("#btnRegister").css("background-color", self.btnBackColor);
          //$("#btnRegister").css("color", self.btntextColor);
          $(".acnhDescription").css("border-color", self.btnBackColor);
          if (!self.AllowRegistration) {
            //alert("1");
            var btnRegister = document.getElementById("btnRegister");
            btnRegister.setAttribute("disabled", "disabled");
            btnRegister.textContent = "Registration Closed";
            btnRegister.style.backgroundColor = "grey";
          }
        });
      //------------------------------------------------------------------------------
    },
    goForEventList: function () {
      //router.push({ name: "EventListReg" });
      debugger;
      router.push({
        path: "/register/" + self.clientID,
      });
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    goForRegister: function () {
      router.push({
        path: "/reg/" + self.eventID,
      });
    },
  },
};
</script>